<template>
  <div class="tour_sub_wrap">
    <iframe src="https://m.blog.naver.com/kogasblog/222117489594" frameborder="0" />
  </div>
</template>
<script>
// import * as appEvent from '@/assets/js/app_event.js'
export default {
  name: 'KogasIntro',
  methods: {
  }
}
</script>
<style scoped>
  iframe {
    width:100%;
    height: calc(100vh - 100px);
  }
  .tour_sub_wrap {
    padding-bottom: 0px;
  }
</style>
